// extracted by mini-css-extract-plugin
export default {"error":"a9067c","error_icon":"eb6f90","errorIcon":"ddf05d","error__icon":"ddf05d","error__text":"ba435d","errorText":"ba435d"};